export const QUALITY_CONTROL_SUCCESS_DELAY_MS = 2000;
export const QUALITY_CONTROL_SLIDE_DURATION_MS = 450;
